import { Button } from "@/components/shared/Button/Button";
import { Input } from "@/components/shared/Input/Input";
import { PhoneInput } from "@/components/shared/PhoneInput/PhoneInput";
import Divider from "@/components/shared/Divider/Divider";
import LayoutOutside from "@/layout/LayoutOutside";
import Title from "@/components/shared/Title/Title";
import Global from "@/assets/icons/Global";
import { ArrowRight } from "lucide-react";
import { useRegister } from "./hooks/useRegister";
import { useTranslation, Trans } from "react-i18next";

export function Register() {
  const {
    onSubmit,
    handleSubmit,
    register,
    errors,
    isRegistering,
    setValue,
    isError,
    isSuccess,
    defaultValues,
    isEmailLocked,
  } = useRegister();

  const { t, i18n } = useTranslation("common");
  const locale = i18n.language || "pt";

  return (
    <LayoutOutside
      isLoading={isRegistering}
      isError={isError}
      isSuccess={isSuccess}
      route="/login"
      text={t("login")}
      classNameMainContainer="mt-[5%]"
    >
      <form
        className="space-y-6 rounded-lg md:max-w-md w-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <header className="flex flex-col gap-4 mb-6">
          <Global />
          <Title text={t("createAccount")} />
        </header>

        <Input
          label={t("name")}
          placeholder={t("namePlaceholder")}
          {...register("name")}
          helperText={errors?.name?.message}
          data-cy="input-name"
        />

        <Input
          label={t("email")}
          type="email"
          placeholder={t("email_placeholder")}
          {...register("email")}
          helperText={errors?.email?.message}
          disabled={isEmailLocked}
          data-cy="input-email"
        />

        <PhoneInput
          label={t("phone")}
          phone_prefix={defaultValues?.phone_prefix}
          onChangePhone={(value, prefix) => {
            setValue("phone", value);
            setValue("phone_prefix", prefix);
          }}
          helperText={errors?.phone?.message}
          data-cy="input-phone"
        />

        <div className="w-full">
          <Input
            type="password"
            label={t("password")}
            placeholder={t("password_placeholder")}
            {...register("password")}
            helperText={errors?.password?.message}
            data-cy="input-password"
          />
          <p className="text-xs text-gray-500">{t("passwordRule")}</p>
        </div>

        <Input
          type="password"
          label={t("confirmPassword")}
          placeholder={t("confirma_password_placeholder")}
          {...register("password_confirmation")}
          helperText={errors?.password_confirmation?.message}
          data-cy="input-confirm-password"
        />

        <Button
          variant="primary"
          className="w-full"
          type="submit"
          disabled={isRegistering}
          data-cy="submit-button"
        >
          {t("continue")} <ArrowRight />
        </Button>

        <Divider />

        <p className="text-start text-xs text-muted-foreground mt-6 md:mt-8">
          <Trans
            i18nKey="account_creation_notice"
            components={{
              1: (
                <a
                  href="https://mundpay.com/seller-agreement"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-interactive"
                />
              ),
              2: (
                <a
                  href={
                    locale === "pt"
                      ? "https://mundpay.com/politica-de-privacidade/"
                      : "https://mundpay.com/en/politica-de-privacidade"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-interactive"
                />
              ),
            }}
          >
            {t("account_creation_notice")}
          </Trans>
        </p>
      </form>
    </LayoutOutside>
  );
}